if (!customElements.get('blog-toggle')) {
  customElements.define(
    'blog-toggle',
    class BlogToggle extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const pill = e.target.closest('[data-target]');
          if (!pill) return;
          this.switchCondition(pill.dataset.target);
        });

        // Equalize panel heights so switching tabs doesn't shift content
        requestAnimationFrame(() => this.equalizeHeights());
      }

      equalizeHeights() {
        const wrap = this.querySelector('[data-condition-panels]');
        if (!wrap) return;

        const panels = [...wrap.querySelectorAll('[data-condition]')];
        let maxHeight = 0;

        panels.forEach(panel => {
          const wasHidden = panel.classList.contains('hidden');
          if (wasHidden) {
            panel.style.visibility = 'hidden';
            panel.classList.remove('hidden');
          }
          maxHeight = Math.max(maxHeight, panel.scrollHeight);
          if (wasHidden) {
            panel.classList.add('hidden');
            panel.style.visibility = '';
          }
        });

        if (maxHeight > 0) wrap.style.minHeight = `${maxHeight}px`;
      }

      switchCondition(target) {
        this.querySelectorAll('[data-target]').forEach((pill) => {
          pill.classList.toggle('active', pill.dataset.target === target);
        });

        this.querySelectorAll('[data-condition]').forEach((panel) => {
          const isTarget = panel.dataset.condition === target;
          panel.classList.toggle('hidden', !isTarget);
          if (isTarget) {
            const carousel = panel.querySelector('swiper-carousel');
            if (carousel) carousel.reinit();
          }
        });
      }
    }
  );
}
